/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import React, { useCallback, useEffect, useMemo, useState } from "react";

import {
  AppBar,
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import breakpoints from "assets/theme/base/breakpoints";

import DeleteModal from "components/deletemodal/deletemodal";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Link, useNavigate, useParams } from "react-router-dom";

import TimelineItem from "components/Icon/TimelineItem";
import MDBox from "components/MDBox";

import { GridSearchIcon } from "@mui/x-data-grid";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import LoadingModal from "components/LoadingModel/loadingModal";
import MDButton from "components/MDButton";
import { useMaterialUIController } from "context";
import PageTitle from "examples/PageTitle/PageTitle";
import { useDispatch } from "react-redux";
import { addBatGroup, deleteBatVehicleRecords, fetchBatVehicle, getBatGroupById, updateBatGroup } from "utils/api";
import { appConstants } from "utils/appConstants";
import { getScreenRight, showResMsg, validateField } from "utils/generic";
import { genericMessage } from "utils/genericMessages";

// inside your component
const errMsg = {
  color: `red`,
  fontSize: `11px`,
};

let fetchedbat;

function EditBATGroup() {
  // const id = window.location.pathname.split('/').pop();
  const { id } = useParams();

  const defaultHrMarginLeft = 20;
  const [table, setTable] = useState("BATGroup");
  const [hrWidth, setHrWidth] = useState(151);
  const [hrMarginLeft, setHrMarginLeft] = useState(defaultHrMarginLeft);
  const [showBATVehicles, setshowBATVehicles] = useState(false);
  const [showBATGroup, setshowBATGroup] = useState(false);
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [screenName, setScreenName] = useState("Add New BAT Group");
  const [batGroupNameErr, setBatGroupNameErr] = useState(false);
  const [tareWeightErr, setTareWeightErr] = useState(false);
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);

  const [deleteHeading, setDeleteHeading] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const { barColor } = getColorMappings(sidenavColor);
  const [batID, setBatID] = useState("");
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [disableColor, setDisableColor] = useState(false);
  const [title, setTitle] = useState("");
  const [values, setValues] = React.useState({
    _id: [],
    businessUserID: JSON.parse(sessionStorage.getItem('LOGIN_DETAILS')).businessUserID,
    batGroupName: "",
    tareWeight: "",
    temperatureType: "Quad",
    batGroupStatus: "Active",
    searchParameter: '',
    searchParameterList: ["batGroupStatus", "temperatureType", "tareWeight", "batGroupName",],
  });

  let mandateFlag = false;
  values.id = batID;

  const [values1, setValues1] = React.useState({
    _id: [],
    vehicleCategory: '',
    registrationNumber: '',
    vehicleMakeModel: '',
    vehicleManufacturingYear: '',
    vinChassisNumber: '',
    engineNumber: '',
    page: appConstants.page,
    limit: appConstants.limit,
    sortingType: "",
    sortingField: "",
    filterValues: "",
    searchParameterList: ['vehicleCategory', 'registrationNumber', 'vehicleMakeModel', 'vehicleManufacturingYear', 'vinChassisNumber', 'engineNumber'],
  });

  useEffect(() => {
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }

    /** 
       The event listener that's calling the handleTabsOrientation function when resizing the window.
      */
    window.addEventListener("resize", handleTabsOrientation);

    // Call the handleTabsOrientation function to set the state with the initial value.
    handleTabsOrientation();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);


  useEffect(() => {
    (async () => {
      getRight()
      if (id !== undefined) {
        values._id = id;
        setScreenName("Edit Bat Group")
        getBatGroupById(values, (data) => {
          if (data.Result_Output.length > 0) {
            fetchedbat = data.Result_Output[0];
            setValues(fetchedbat);
            setBatID(data.Result_Output._id)
          }
        }, dispatch)
      }
    }
    )();
  }, []);

  async function getRight() {
    let right = await getScreenRight("BAT Group")
    if (right === "Full Access")
      setDisableColor(false)
    else setDisableColor(true)
  }

  const handleChange = (name) => (event) => {
    if (event.target.validity !== undefined && event.target.validity.valid === true) {
      setValues({ ...values, [name]: event.target.value });
    }
    else if (event.target.validity === undefined) {
      setValues({ ...values, [name]: event.target.value });
    }
  };

  const handlePageChange = page => {
    values1.page = page;
    fetchDocument();
  };
  const handlePerRowsChange = async (newPerPage, page) => {
    values1.page = page;
    values1.limit = newPerPage
    setPerPage(newPerPage);
  };
  const handleSort = async (type, value) => {
    values1.sortingType = value;
    values1.sortingField = type;
  };
  const contextActions = useMemo(() => {
    const handleDeleteMultiple = () => {
      if (toggleCleared) setSelectedRows([])
      setDeleteDialogeFlag(!deleteDialogeFlag);
      setDeleteHeading("Would you like to delete selected records?");
      if (selectedRows) {
        values1._id = []
        for (let element of selectedRows) {
          values1._id.push(element._id);
        }
      }
    };
    return (
      <MDButton onClick={handleDeleteMultiple} color="error" >
        Delete
      </MDButton>
    );
  }, [selectedRows, toggleCleared]);

  const handleRowSelected = useCallback(state => {
    setSelectedRows(state.selectedRows);
    if (state.selectedRows.length > 0)
      setTitle(" ");
    else {
      setTitle("");
      setDeleteHeading("");
    }
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem("PARA_TABLE") === 'BATVehicles') {
      setTable('BATVehicles');
    }
    if (table === "BATGroup") {
      setshowBATGroup(true);
      setshowBATVehicles(false);
      setHrWidth(135);
      setHrMarginLeft(229);
      setTabValue(0)
    } else if (table === "BATVehicles") {
      setshowBATGroup(false);
      setshowBATVehicles(true);
      setHrWidth(135);
      setHrMarginLeft(229);
      fetchDocument();
      setTabValue(1)
    }
    sessionStorage.removeItem("PARA_TABLE");
  }, [table]);


  const clearErrorStates = () => {
    setBatGroupNameErr(false)
    setTareWeightErr(false)
  };

  const updateBG = () => {
    mandateFlag = false;
    clearErrorStates()
    mandateFlag = validateField(values.batGroupName, setBatGroupNameErr) || mandateFlag;
    mandateFlag = validateField(values.tareWeight, setTareWeightErr) || mandateFlag;
    if (mandateFlag) {
      return;
    }
    values.id = batID

    if (batID !== "") {
      updateBatGroup(values, (data) => {
        showResMsg(data.Result_Status ? genericMessage.updated : data.Result_Message, 1000, data.Result_Status, navigate, "/batGroup");
      }, dispatch)
    } else {

      values._id = undefined
      addBatGroup(values, (data) => {
        showResMsg(data.Result_Status ? genericMessage.added : data.Result_Message, 1000, data.Result_Status, navigate, "/batGroup");
        if (data.Result_Status) {
          setBatID(data.Result_Output._id)
        }
      }, dispatch)

    }
  };

  const handleDeleteDialogeClick = async (_id) => {
    values1._id = []
    values1._id.push(_id)
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleCancel = name => event => {
    setDeleteDialogeFlag(false);
  };

  const handleDelete = async (_id) => {
    deleteBatVehicle();
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const fetchDocument = async () => {
    values1._id = id;
    fetchBatVehicle(values1, (data) => {
      setTotalRows(data.Result_Output.totalDocs);
      setRows(data.Result_Output.docs)
    }, dispatch)
  }

  const deleteBatVehicle = async () => {
    sessionStorage.setItem("PARA_TABLE", "BATVehicles");
    console.log("gch", values1._id);

    deleteBatVehicleRecords(values1, (data) => {
      if (data.Result_Status){
        fetchDocument()
        setToggleCleared(true)
      }
        showResMsg(data.Result_Status ? genericMessage.deleted : data.Result_Message, 1000, data.Result_Status, navigate, '/batGroup/editBATGroup/' + id);
     
    }, dispatch)
  };


  const BATGroup = (
    <>
      {showBATGroup && (
        <>
          <MDBox mt={6} mb={3}>
            <Grid container spacing={2} sx={{ display: "flex", justifyContent: "center" }}>
              <Grid item xs={6} spacing={6}>
                <Card sx={{ boxShadow: "none" }}>
                  <MDBox pt={4} pb={3} px={3}>
                    <Grid container rowGap={3}>
                      <Grid item xs={12} lg={12}>
                        <MDBox component="form" role="form">
                          <TextField
                            type="text"
                            label="BAT Group Name"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              pattern: "^[a-zA-Z0-9 ]+$",
                              maxLength: 30
                            }}
                            onChange={handleChange("batGroupName")}
                            value={values.batGroupName}
                          />
                          {batGroupNameErr ? <span style={errMsg}>Bat Group Name can't be blank</span> : ""}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={12}>
                        <MDBox component="form" role="form">
                          <TextField
                            type="text"
                            label="Tare Weight"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              pattern: "^[0-9.]+$",
                              maxLength: 10
                            }}
                            onChange={handleChange("tareWeight")}
                            value={values.tareWeight}
                          />
                          {tareWeightErr ? <span style={errMsg}>Tare Weight can't be blank</span> : ""}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={12}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">Temperature Type</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            name="userType"
                            id="demo-simple-select"
                            style={{ minHeight: "44.11px" }}
                            label="Temperature Status"
                            onChange={handleChange("temperatureType")}
                            value={values.temperatureType}
                          >
                            <MenuItem value="Quad">Quad</MenuItem>
                            <MenuItem value="M Quad">M Quad</MenuItem>
                            <MenuItem value="S Quad">S Quad</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} lg={12}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">BAT Group Status</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            name="userType"
                            id="demo-simple-select"
                            style={{ minHeight: "44.11px" }}
                            label="BAT Group Status"
                            onChange={handleChange("batGroupStatus")}
                            value={values.batGroupStatus}
                          >
                            <MenuItem value="Active">Active</MenuItem>
                            <MenuItem value="Inactive">Inactive</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </MDBox>
                </Card>
              </Grid>
            </Grid>
            <Grid
              container
              mt={2}
              columnSpacing={4}
              alignItems="center"
              display="flex"
              justifyContent="center"
            >
              <Grid item xs={12} md={4} spacing={2} lg={1.2}>
                <Link to={"/batGroup"}>
                  <MDButton
                    className="btn-block center-container-btn btn-warning btn-back rightSpace"
                    color="warning"
                    fullWidth
                  >
                    Cancel
                  </MDButton>
                </Link>
              </Grid>
              <Grid item xs={12} md={4} spacing={2} lg={1.2}>
                <MDButton
                  onClick={updateBG}
                  rel="noreferrer"
                  variant="gradient"
                  color="success"
                  fullWidth
                >
                  {id !== undefined ? <>Update</> : <>Save</>}

                </MDButton>
              </Grid>
            </Grid>
          </MDBox>
        </>
      )}
    </>
  );

  const handleSearchFilter = (event) => {
    setValues1({ ...values1, filterValues: event.target.value });
  };

  let columns = [
    {
      name: "Vehicle Category",
      selector: row => row.vehicleCategory,
      sortable: true,
      sortField: 'vehicleCategory',
    },
    {
      name: "Registration Number",
      selector: row => row.registrationNumber,
      sortable: true,
      sortField: 'registrationNumber',
    },
    {
      name: "Vehicle Make Model",
      selector: row => row.vehicleMakeModel,
      sortable: true,
      sortField: 'vehicleMakeModel',
    },
    {
      name: "Vehicle Manufacturing Year",
      selector: row => row.vehicleManufacturingYear,
      sortable: true,
      sortField: 'vehicleManufacturingYear',
    },
    {
      name: "VIN/Chassis Number",
      selector: row => row.vinChassisNumber,
      sortable: true,
      sortField: 'vinChassisNumber',
    },
    {
      name: "Engine Number",
      selector: row => row.engineNumber,
      sortable: true,
      sortField: 'engineNumber',
    },

    {
      name: "Actions",
      selector: row => row._id,
      center: true,
      cell: (row) => (
        <>
          <Grid container justifyContent={"center"} mr={2} spacing={4} mt={-6.2}>
            <Grid item>
              <Link
                to={`/batGroup/editBATGroup/editBATVehicle/edit/${row._id}`}
              >
                <TimelineItem color="success" icon="edit" title="Edit" />
              </Link>
            </Grid>
            <Grid item >
              <TimelineItem
                color="error"
                icon="delete"
                onClick={() => handleDeleteDialogeClick(row._id)}
                title="Delete"
              />
            </Grid>

          </Grid>
        </>
      ),
    },
  ];

  const BATVehicles = (
    <>
      {showBATVehicles && (
        <>
          <Card color="primary" sx={{ marginTop: "30px" }}>
            {/* <PageTitle screenName="Standard Features" /> */}
            <Grid container display={"flex"} justifyContent="end" px={2.2} gap={2}>

              <Grid lg={2.5} xs={6}>
                <TextField
                  type="text"
                  variant="outlined"
                  fullWidth
                  className="searchButton"
                  placeholder="Search..."
                  label="Search Filter"
                  value={values1.filterValues}
                  onChange={handleSearchFilter}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment>
                        <Button style={{ borderRadius: "0px 0.5rem  0.5rem 0px", boxShadow: "none", background: barColor }} variant="contained" onClick={fetchDocument}>
                          <GridSearchIcon color="white" />
                        </Button>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <div style={{ marginRight: '16px' }}>
                <Link to={`/batGroup/editBATGroup/addBATVehicle/${values._id}`}>
                  <MDButton
                    variant="contained"
                    className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                    color={disableColor ? "secondary" : "success"}
                  >
                    Add New
                  </MDButton>
                </Link>
              </div>
            </Grid>
            <CardContent>
              <BTable
                title={title}
                columns={columns}
                data={rows}
                selectableRows
                // onSort={handleSort}
                sortingType={handleSort}
                sortServer
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                contextActions={contextActions}
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggleCleared}
                fixedHeaderScrollHeight="410px"
                fixedHeader={true}

              />
            </CardContent>
          </Card>
        </>
      )
      }
    </>
  );

  const renderTable = () => {
    return (
      <>
        {BATGroup}
        {BATVehicles}
      </>
    );
  };
  const handleSetTabValue = (event, newValue) => setTabValue(newValue);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={2}>
        <Card>
          <PageTitle screenName={screenName} />
          <Grid container>
            <Grid item xs={12} md={6} lg={6} px={2} mb={-3.5}>
              <AppBar position="inherit">
                <Tabs
                  orientation={tabsOrientation}
                  value={tabValue}
                  onChange={handleSetTabValue}
                  indicatorColor={"primary"}
                  sx={{
                    "& .Mui-selected": { color: "#fff !important" },
                  }}
                >
                  <Tab disabled={batID === "" ? true : false} onClick={() => setTable("BATGroup")} label="BAT Group" />
                  <Tab disabled={batID === "" ? true : false} onClick={() => setTable("BATVehicles")} label="BAT Vehicles" />
                </Tabs>
              </AppBar>
            </Grid>
          </Grid>
          {renderTable()}
        </Card>
      </MDBox>
      <DeleteModal
        open={deleteDialogeFlag}
        handleDelete={handleDelete}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}
        heading={deleteHeading}
      />
      <LoadingModal loading={loading} />
    </DashboardLayout>
  );
}

export default EditBATGroup;
